export const quote = {
  quote: {
    confirmDialog: {
      name: "Nome:",
      description: "Descrição:",
      validity: "Esta cotação é válida até {{ expirationTime }}",
      option: {
        yes: "Sim",
        no: "Não"
      },
      buyer: {
        submit: {
          a11y: {
            close: "Fechar modal de submissão de cotação"
          },
          title: "Submeter Pedido de Cotação {{ code }}?",
          confirmNote: "Tem a certeza de que deseja submeter este pedido de cotação?",
          successMessage: "Pedido de cotação submetido com sucesso"
        },
        cancel: {
          a11y: {
            close: "Fechar modal de cancelamento de cotação"
          },
          title: "Cancelar Pedido de Cotação {{ code }}?",
          confirmNote: "Tem a certeza de que deseja cancelar esta cotação?",
          successMessage: "Pedido de cotação cancelado"
        }
      },
      buyer_offer: {
        edit: {
          a11y: {
            close: "Fechar modal de edição de cotação"
          },
          title: "Confirmar Edição de Cotação {{ code }}?",
          confirmNote: "Tem a certeza de que deseja editar esta cotação aprovada?",
          warningNote: "Esta cotação foi aprovada. Editar esta cotação impedirá o checkout até que as novas alterações sejam aprovadas."
        },
        cancel: {
          a11y: {
            close: "Fechar modal de cancelamento de cotação"
          },
          title: "Cancelar Cotação {{ code }}?",
          confirmNote: "Tem a certeza de que deseja cancelar esta cotação?",
          successMessage: "Cotação cancelada"
        },
        checkout: {
          a11y: {
            close: "Fechar modal de checkout de cotação"
          },
          title: "Checkout da Cotação {{ code }}?",
          confirmNote: "Tem a certeza de que deseja aceitar e finalizar o checkout desta cotação?"
        }
      },
      expired: {
        edit: {
          a11y: {
            close: "Fechar modal de edição de cotação"
          },
          title: "Confirmar Edição de Cotação {{ code }}?",
          confirmNote: "Tem a certeza de que deseja editar esta cotação expirada?",
          warningNote: "Esta cotação está expirada. Editar esta cotação impedirá o checkout até que as novas alterações sejam aprovadas."
        },
        requote: {
          a11y: {
            close: "Fechar modal de recriação de cotação"
          },
          title: "Recriar Pedido de Cotação {{ code }}?",
          confirmNote: "Tem a certeza de que deseja recriar este pedido de cotação?",
          warningNote: "Esta cotação está expirada. Recriá-la gerará um novo pedido de cotação com o mesmo conteúdo, que poderá ser editado e submetido para aprovação posteriormente."
        }
      },
      seller: {
        submit: {
          a11y: {
            close: "Fechar modal de submissão de cotação"
          },
          title: "Submeter Cotação {{ code }}?",
          confirmNote: "Tem a certeza de que deseja submeter esta cotação?",
          warningNote: "Dependendo do valor total da cotação, poderá ser necessária uma aprovação adicional antes de o comprador poder finalizar o checkout desta cotação.",
          successMessage: "Cotação submetida com sucesso"
        }
      },
      sellerapprover: {
        approve: {
          a11y: {
            close: "Fechar modal de aprovação de cotação"
          },
          title: "Aprovar Cotação {{ code }}?",
          confirmNote: "Tem a certeza de que deseja aprovar esta cotação?",
          successMessage: "Cotação aprovada com sucesso"
        },
        reject: {
          a11y: {
            close: "Fechar modal de rejeição de cotação"
          },
          title: "Rejeitar Cotação {{ code }}?",
          confirmNote: "Tem a certeza de que deseja rejeitar esta cotação?",
          successMessage: "Cotação rejeitada"
        }
      },
      cancelled: {
        requote: {
          a11y: {
            close: "Fechar modal de recriação de cotação"
          },
          title: "Recriar Pedido de Cotação {{ code }}?",
          confirmNote: "Tem a certeza de que deseja recriar este pedido de cotação?",
          warningNote: "O seu carrinho atual será convertido num carrinho guardado."
        }
      },
      all: {
        edit: {
          a11y: {
            close: "Fechar modal de edição de cotação"
          },
          title: "Editar Cotação {{ code }}?",
          confirmNote: "Tem a certeza de que deseja editar esta cotação?",
          warningNote: "O seu carrinho atual será convertido num carrinho guardado."
        }
      }
    },
    comments: {
      regionTitle: "Caja de contacto/comentarios",
      title: "Contato",
      invalidComment: "Bilhete inválido - Por favor, tente novamente...",
      allProducts: "Todos os produtos"
    },
    commons: {
      requestQuote: "Solicite um orçamento",
      cart: "Carrinho de compras",
      minRequestInitiationNote: "Um subtotal mínimo de {{ minValue }} é necessário para enviar uma cotação",
      minRequestWeightNote: "Para solicitar uma cotação, o peso total deve ser no mínimo {{ weight }} Kg.",
      savedActiveCart: "Seu carrinho ativo tornou-se o carrinho salvo {{ code }}",
      contractProductsInCartNote : "Não é possível solicitar cotações para produtos promocionais:"
    },
    header: {
      buyerEdit: {
        a11y: {
          cancel: "Cancelar a edição de informações do cabeçalho da cotação",
          save: "Salvar informações do cabeçalho da cotação"
        }
      },
      overview: {
        regionTitle: "Resumo dos detalhes da cotação",
        id: "ID Cotação",
        status: "Estado",
        information: "Informações de cotação",
        name: "Número",
        description: "Descrição",
        charactersLeft: "caracteres restantes: {{count}}",
        priceAndExpiry: "Preço e validade",
        estimatedTotal: "Total estimado",
        total: "Total",
        expirationTime: "Data de validade",
        a11y: {
          edit: "Editar informações do cabeçalho da cotação"
        },
        createdAndUpdated: "Criado e atualizado",
        createdDate: "Criado",
        lastUpdatedDate: "Ultima atualização"
      }
    },
    httpHandlers: {
      cartValidationIssue: "Existem problemas com seus ingressos. Por favor, verifique seu carrinho.",
      quoteCartIssue: "Não é possível fazer alterações nas entradas no carrinho. Prossiga para a finalização da compra",
      absoluteDiscountIssue: "Escolha um desconto que não exceda o valor total",
      expirationDateIssue: "Escolha uma data de validade no futuro",
      threshold: {
        underThresholdError: "O preço total da cotação solicitada não atende ao limite mínimo"
      },
      expired: "Esta cotação expirou. Você deve enviar sua RFQ novamente para receber outra oferta do fornecedor.",
      downloadPDFError: "Algo deu errado. O documento PDF da proposta não pôde ser obtido."
    },
    items: {
      regionTitle: "Itens do carrinho"
    },
    links: {
      newCart: "Novo carrinho",
      quotes: "Cotações",
      download: "Baixar proposta",
      a11y: {
        newCart: "Crie um novo carrinho vazio e navegue até ele.",
        quotes: "Navegue até a lista de resultados da pesquisa de cotações.",
        download: "Comece a baixar uma proposta de cotação"
      }
    },
    list: {
      regionTitle: "Resumo da lista de cotações",
      title: "Lista de cotações",
      name: "Número",
      updated: "Atualizado",
      sortBy: "Classificar por",
      sortQuotes: "Ordenar cotações",
      empty: "Não temos registros de cotações para esta conta.",
      quoteId: "ID Cotação",
      status: "Estado",
      clickableRow: "Clique na linha para mais detalhes da cotação"
    },
    states: {
      BUYER_DRAFT: "Rascunho",
      BUYER_SUBMITTED: "Enviado",
      BUYER_ACCEPTED: "Aprovado",
      BUYER_APPROVED: "Aprovado",
      BUYER_REJECTED: "Indeferido",
      BUYER_OFFER: "Cotação do fornecedor",
      BUYER_ORDERED: "Ordem",
      SELLER_DRAFT: "Rascunho",
      SELLER_REQUEST: "Solicitado",
      SELLER_SUBMITTED: "Enviado",
      SELLERAPPROVER_DRAFT: "Rascunho",
      SELLERAPPROVER_PENDING: "Aprovação pendente",
      SELLERAPPROVER_APPROVED: "Aprovado",
      SELLERAPPROVER_REJECTED: "Indeferido",
      CREATED: "Criado",
      CANCELLED: "Cancelado",
      EXPIRED: "Expirado"
    },
    summary: {
      regionTitle: "Resumo do pedido",
      actions: {
        APPROVE: "Aprovar cotação",
        CANCEL: "Cancelar orçamento",
        CHECKOUT: "Aceite e pague",
        EDIT: "Editar cotação",
        REJECT: "Rejeitar cotação",
        REQUOTE: "Solicite um novo orçamento",
        SAVE: "Salvar orçamento",
        SUBMIT: "Enviar Orçamento",
        VIEW: "Ver cotação"
      },
      prices: {
        title: "Resumo do pedido",
        subtotal: "Subtotal",
        productDiscount: "Desconto de item",
        orderDiscount: "Desconto para pedidos",
        quoteDiscount: "Desconto de cotação",
        total: "Total",
        hint: "Nenhum imposto está incluído no total"
      },
      sellerEdit: {
        discount: "Desconto",
        apply: "Aplicar",
        expiryDate: "Data de validade",
        discountValidationText: "Insira uma porcentagem de desconto válida",
        a11y: {
          apply: "Clique para aplicar o valor de desconto inserido a esta cotação",
          discount: "Insira um desconto percentual para aplicar a esta cotação",
          expiryDate: "Insira uma data de validade para esta cotação"
        }
      }
    }
  }
}
